import { COLORS, RegularButtonWrapper } from '@monthio/react-components'
import styled from 'styled-components'

export const FlowRedirectConfirmDescription = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 40px;
`

export const FlowCount = styled.span`
	background-color: ${COLORS.BACKGROUND_LIGHTER};
	padding: 8px 16px;
	color: ${COLORS.BRAND_COLORS.DARK_BLUE_LIGHT};
	border-radius: 4px;
`

export const FlowRedirectConfirmRedirectionURL = styled.a`
	font-weight: bold;
	padding: 8px 0px;
	color: ${COLORS.BRAND_COLORS.DARK_BLUE_LIGHT};
	border-radius: 4px;
`

export const ActionWrapper = styled.div`
	display: flex;
	flex-flow: row wrap-reverse;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin-left: 8px;
	margin-right: 8px;
`

export const DownLoadButtonsContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-flow: row wrap;
	margin-left: 8px;
	margin-right: 8px;

	${RegularButtonWrapper} {
		width: 300px;
		padding: 8px;
	}
`
